import css from './index.module.scss';
import NextImage from '@/components/NextImage';
import { useGlobal } from '@/utils/useGlobal';

export default function ViewDesc() {
    const { useLang } = useGlobal();
    const { t } = useLang('400wrigidsolarpanel');

    return (
        <>
            <section className={`${css.componentRoot} ViewDesc`}>
                <article className="title-box">{t('solarpanels_400w_rigid.viewDesc_title')}</article>
                <div className="bg-box">
                    <div className="image-box">
                        <NextImage
                            webpSrc={require('@publicLocal/product/solarpanel_400w_rigid/h5/08.webp')}
                            src={require('@publicLocal/product/solarpanel_400w_rigid/h5/08.png')}
                            className="fullImgs"
                            alt={t('solarpanels_400w_rigid.viewDesc_title')}
                        />
                    </div>
                    <article className="details-box">{t('solarpanels_400w_rigid.viewDesc_details')}</article>
                </div>
            </section>
        </>
    );
}
